<template>
  <ul class="list-group">
    <li
      @click="onDetail(t)"
      class="list-group-item list-group-item-action d-flex align-items-center bd-0"
      v-for="(t, i) in tasks"
      :key="i"
      role="button"
    >
      <div class="avatar">
        <span
          :class="`avatar-initial rounded-circle bg-transparent bd bd-gray-900`"
        >
          <feather
            type="external-link"
            class="tx-color-02"
            style="margin-top: -4px; width: 19px; height: 19px;"
          ></feather>
        </span>
      </div>
      <div class="pd-l-10">
        <h6 class="tx-14 tx-semibold mg-b-5">{{ t.task }}</h6>
        <span class="d-block tx-11 text-muted">{{ t.taskDesc }}</span>
      </div>

      <!-- <div class="wd-100p d-flex">
        <div class="avatar">
          <feather type="external-link" class="wd-35-f ht-35-f"></feather>
        </div>
        
      </div> -->
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getLessonIcon(t) {
      let rv = "";
      if (t.im != null && t.im.isDone) {
        rv = "check";
      } else if (t.i == 1 && t.im == null) {
        rv = "lock";
      } else {
        return "square";
      }
      return rv;
    },
    getLessonIconBg(t) {
      let rv = "";
      if (t.im != null && t.im.isDone) {
        rv = "bg-success-light";
      } else if (t.i == 1 && t.im == null) {
        rv = "bg-danger";
      } else {
        return "";
      }
      return rv;
    },
    onDetail(t) {
      window.open(t.taskDesc, "_blank");
    }
  }
};
</script>

<style></style>
